import { Sport } from '@betterpool/api-types/contests-service';

import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

const getSportText = (sport: Sport) => {
  switch (sport) {
    case Sport.GOLF:
      return 'Golf';
    case Sport.FOOTBALL:
      return 'Football';
    case Sport.SOCCER:
      return 'Soccer';
    case Sport.BASEBALL:
      return 'Baseball';
    case Sport.BASKETBALL:
      return 'Basketball';
    case Sport.HOCKEY:
      return 'Hockey';

    default:
      return 'Unknown';
  }
};

const getSlatesName = (slates?: ContestSlate[]) => {
  if (!slates || slates.length === 0) return '-';

  const [firstSlate] = slates;
  if (slates.length === 1) return firstSlate.name;

  const lastSlate = slates[slates.length - 1];

  return `${firstSlate.name} - ${lastSlate.name}`;
};

export { getSportText, getSlatesName };
